<template>
  <!--用户-->
  <div class="user-list" @click="details(options)">
    <div style="width: 60px;height: 60px;float:left;">
      <el-avatar shape="square" fit="cover" :src="options.image" style="height: inherit;width: inherit;"/>
    </div>
    <div>
      <p class="el-span SourceHanSansCN">{{ options.title }}</p>
      <i class="status-success" v-if="options.status==1">在业</i>
      <p class="keyword">{{ options.keyword }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "user",
  data(){
    return{
      cid:0,
    }
  },
  props: {
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods:{
    details(row){
      let routeData = this.$router.resolve({
        name: "userInfo",
        query:{bid:row.bid, type:row.type},
        params:{cid:this.cid},
        path: '/userInfo/index',
      });
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.user-list {
  display: flex;
  padding: 20px 0px 0px;

  .el-span {
    padding-left: 15px;
    margin-block-start: 0em;
    padding-bottom: 8px;
    margin-block-end: 0em;
    font-size: 18px;
  }

  .status-success {
    font-style: normal;
    margin-left: 15px;
    padding: 3px 10px;
    background: #2FE4BD;
    color: #ffffff;
    font-size: 14px;
  }

  .keyword {
    font-size: 14px;
    margin-left: 15px;
    overflow: hidden;
    max-height: 35px;
    /*  超出的文本隐藏 */
    display: -webkit-box;
    /* 将对象作为弹性伸缩盒子模型显示。 */
    -webkit-line-clamp: 1;
    /* 这个属性不是css的规范属性，需要组合上面两个属性，表示显示的行数。 */
    -webkit-box-orient: vertical;
    /* 从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式） */
    margin-block-start: 0em;
    margin-block-end: 0em;
    padding-top: 8px;
  }
}
</style>